module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.6"},{"quantity":0.03,"color":"#91E3AD","label":"0.6 - 1.17"},{"quantity":0.06,"color":"#DEFFB0","label":"1.17 - 2.02"},{"quantity":0.01,"color":"#FFE68C","label":"2.02 - 3.19"},{"quantity":9,"color":"#FF9982","label":"3.19 - 4.71"},{"quantity":12,"color":"#FF4D30","label":"4.71 - 6.96"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_80_wheat.json
// module id = 77Nb
// module chunks = 171